import React from 'react';
import { CheckSquare, Target } from 'lucide-react';

const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Target className="w-5 h-5 mr-2 text-indigo-500" />
        Дополнительные параметры инвестирования
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Целевые компании */}
        <div className="col-span-full">
          <label htmlFor="targetCompanies" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Целевые компании в сфере ИИ
          </label>
          <input
            type="text"
            id="targetCompanies"
            name="targetCompanies"
            value={formData.targetCompanies.join(', ')}
            onChange={(e) => {
              const companies = e.target.value.split(',').map(company => company.trim()).filter(Boolean);
              handleInputChange({
                target: {
                  name: 'targetCompanies',
                  value: companies
                }
              });
            }}
            className="form-input w-full"
            placeholder="Например: OpenAI, NVIDIA, Microsoft (через запятую)"
          />
          <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
            Через запятую, без кавычек
          </p>
        </div>

        {/* Проверочные опции */}
        <div className="col-span-full space-y-3">
          {/* Опция: Персонализированный инвестиционный профиль */}
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="personalizedProfile"
              checked={formData.personalizedProfile || false}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Создать персонализированный инвестиционный профиль
            </span>
          </label>

          {/* Опция: Автоматическая диверсификация */}
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="automaticDiversification"
              checked={formData.automaticDiversification || false}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Автоматическая диверсификация инвестиций
            </span>
          </label>

          {/* Опция: Реинвестирование дивидендов */}
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="dividendReinvestment"
              checked={formData.dividendReinvestment || false}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Реинвестирование дивидендов
            </span>
          </label>
        </div>
      </div>

      {/* Информационный блок */}
      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <CheckSquare className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Дополнительные возможности
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Персонализированный профиль и автоматическая диверсификация 
              помогут оптимизировать инвестиционную стратегию с учетом 
              ваших предпочтений и текущей ситуации на рынке ИИ.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;